// extracted by mini-css-extract-plugin
export default {"container":"NewApplicationPage_container__GpC+4","formItem":"NewApplicationPage_formItem__ePr+J"};